import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import { composedAPI } from "./api";
import vlanComposition from "./composition";
import help from "help/viewVLANProfileConfig.md"
import settingsHelp from "help/viewVLANProfileConfigSettings.md"

const ConfigVLANProfiles = ({ ...settings }) => (
  <ProfilesAndSettings
    {...vlanComposition}
    {...composedAPI}
    {...settings}
    help={help} 
    settingsHelp={settingsHelp}
  />
);

export default ConfigVLANProfiles;
